import { ZOOM } from "./constant"; //缩放控制

import Action from "./Action"
/**
 * 时间轴
 */
class TimeLine {

    constructor(opt) {
        this.canvas = opt.canvas;
        this.width = opt.width;
        this.height = opt.height;
        this.timeSegments = opt.timeSegments;
        this.tableData = opt.tableData;
        this.currentZoomIndex = 0;//默认时间范围
        this.totalMS = ZOOM[this.currentZoomIndex] * 60 * 60 * 1000;// 小时——》毫秒
        this.rowInterval = 10;//行高
        this.left = 10; //左间距
        this.top = 30;//上间距


        this.PX_PER_MS = this.width / this.totalMS; // px/ms，每毫秒占的像素
        this.MS_PER_PX = this.totalMS / this.width; // ms/px，每像素占的毫秒
        //this.endX = this.width * this.getEnd() / this.totalMS;//结束位置


        //起点
        this.startRect = {
            size: 10,
            status: "",
            x: 0,
            y: 0,
            w: 10 * 2,
            h: this.height,
        };

        //终点
        this.endRect = {
            size: 10,
            status: "",
            x: this.endX,
            y: 0,
            w: 10 * 2,
            h: this.height,
        };


        //时间段
        this.objTimeSegments = [];
        this.sumH = 0;

        //中间线
        this.hoverLine = {
            x: 0,
            y: 0
        }

        this.mousein = false;
        this.draging = false;
        this.offsetX = 0;
        this.offsetY = 0; // 鼠标相对于图形的偏移量
        this.init(); //初始化
        this.render();
    }
    //初始化画布
    init() {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.ctx = this.canvas.getContext("2d");

        this.tableData2timeSegments();
        this.bindEvent();
        this.endRect.x = this.endX;
        this.height = this.height <= this.sumH ? this.sumH + 80 : this.height;

        //this.canvas.height = this.height;
    }

    setZomm() {
        this.totalMS = ZOOM[this.currentZoomIndex] * 60 * 60 * 1000;// 小时——》毫秒
        //this.endX = this.width * this.getEnd() / this.totalMS;//结束位置

        this.tableData2timeSegments();
        this.endRect.x = this.endX;
        this.render();
    }
    //跟新运行时间
    setTime(time) {

        //const PX_PER_MS = this.width / this.totalMS; // px/ms，每毫秒占的像素//默认半个小时

        this.startRect.x = time * this.PX_PER_MS + this.left;
        this.render();
    }

    //获取开始时间
    getStartTime() {
        this.PX_PER_MS = this.width / this.totalMS; // px/ms，每毫秒占的像素
        this.MS_PER_PX = this.totalMS / this.width; // ms/px，每像素占的毫秒

        let x = this.startRect.x;
        return this.MS_PER_PX * (x - this.left)
    }

    getEndTime() {
        this.PX_PER_MS = this.width / this.totalMS; // px/ms，每毫秒占的像素
        this.MS_PER_PX = this.totalMS / this.width; // ms/px，每像素占的毫秒

        let x = this.endRect.x;
        return this.MS_PER_PX * (x - this.left)
    }
    //获取范围内的动作列表
    getTableData() {

        const MS_PER_PX = this.totalMS / this.width; // ms/px，每像素占的毫秒
        // 使用 sort 方法按照 beginTime 进行排序
        this.objTimeSegments.sort((a, b) => {
            return a.beginTime - b.beginTime;
        });

        let startX = this.startRect.x;
        let endX = this.endRect.x;
        let list = [];
        for (let i = 0; i < this.objTimeSegments.length; i++) {
            if (this.objTimeSegments[i].x >= startX && this.objTimeSegments[i].x <= endX) {
                list.push(this.objTimeSegments[i]);
            }
        }
        return list;
    }

    tableData2timeSegments() {
        console.log(this.tableData);
        let tableData = this.tableData;
        let startTime = 0;
        let endTime = 0;
        let rowTemp = 35 + this.top;
        const MS_PER_PX = this.totalMS / this.width; // ms/px，每像素占的毫秒
        const PX_PER_MS = this.width / this.totalMS; // px/ms，每毫秒占的像素//默认半个小时

        this.objTimeSegments = tableData.map((item, index) => {
            var delay = item.delay * 1000;
            item.continue = 1; //秒
            var continueTime = item.continue * 1000;

            // startTime = index == 0 ? delay : endTime;
            // endTime = index == 0 ? startTime + continueTime : endTime  + delay;

            startTime = index == 0 ? delay : startTime + delay;
            endTime = startTime + continueTime; //动作时长暂不不支持编辑，固定一秒

            let s = {
                item: item,
                beginTime: startTime,
                endTime: endTime,
            };




            let x = startTime * PX_PER_MS;
            let w = (endTime - startTime) * PX_PER_MS;

            x = Math.round(x);
            w = Math.round(w);
            // 避免时间段小于1px绘制不出来
            w = Math.max(1, w);
            let x1 = x + this.left;
            let y1 = index == 0 ? rowTemp : this.sumH + 5;
            let h = this.rowInterval;
            this.sumH = y1 + h;

            let option = {
                item: item,
                x: x1,
                y: y1,
                w: w,
                h: h,
                color: generateRandomColor(),
                index: index,
                MS_PER_PX: MS_PER_PX,
                left: this.left

            };

            return new Action(option);
        });

        this.endX = this.width * endTime / this.totalMS;//结束位置

    }

    initTimeSegments() {

        this.objTimeSegments = [];
        const PX_PER_MS = this.width / this.totalMS; // px/ms，每毫秒占的像素//默认半个小时
        let rowTemp = 35 + this.top;
        this.timeSegments.forEach((item, index) => {
            let x = item.beginTime * PX_PER_MS;
            let w = (item.endTime - item.beginTime) * PX_PER_MS;
            x = Math.round(x);
            w = Math.round(w);
            // 避免时间段小于1px绘制不出来
            w = Math.max(1, w);
            let x1 = x + this.left;
            let y1 = index == 0 ? rowTemp : this.sumH + 5;
            let h = this.rowInterval;
            this.sumH = y1 + h;

            this.objTimeSegments.push({
                name: item.name,
                x: x1,
                y: y1,
                w: w,
                h: h,
                color: item.color,
                status: "",
                index: index
            })
        });
    }

    getEnd() {
        let end = 0;
        for (let i = 0; i < this.timeSegments.length; i++) {
            end = this.timeSegments[i].endTime >= end ? this.timeSegments[i].endTime : end;
        }

        return end;
    }

    bindEvent() {
        let canvas = this.canvas;
        this.onMousemove = this.onMousemove.bind(this);
        this.onMousedown = this.onMousedown.bind(this);
        this.onMouseup = this.onMouseup.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onMouseout = this.onMouseout.bind(this);
        canvas.addEventListener('mousemove', this.onMousemove);
        canvas.addEventListener('mousedown', this.onMousedown);
        canvas.addEventListener('mouseup', this.onMouseup);
        canvas.addEventListener('mouseout', this.onMouseout);
        window.addEventListener("resize", this.onResize)

    }
    onMousedown(event) {
        this.startRect.status = "";//状态恢复
        let canvas = this.canvas;
        const rect = canvas.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;
        if (event.button === 0) {


            this.objTimeSegments.forEach((item, index) => {
                item.status = this.inRectangle(mouseX, mouseY, item) ? "choose" : item.status; //被选中了
                item.status = this.inRectangle(mouseX, mouseY, {
                    x: item.x - 4,
                    y: item.y,
                    w: 8,
                    h: item.h
                }) ? "left" : item.status; //被选中了，左


                if (item.status == "left") {
                    item.x2 = item.x + item.w;
                }

                item.status = this.inRectangle(mouseX, mouseY, {
                    x: item.x + item.w - 4,
                    y: item.y,
                    w: 8,
                    h: item.h
                }) ? "right" : item.status; //被选中了，右

                if (item.status) {
                    canvas.style.cursor = "pointer"; // 更改鼠标样式为小手
                    this.drawRect(item.x, item.y, item.w, item.h, item.color, item.status);
                    this.offsetX = mouseX - item.x;
                }

                console.log(item)
            });

            var resA = this.inRectangle(mouseX, mouseY, this.startRect);
            this.startRect.status = resA ? "choose" : "";//选择状态

            if (this.startRect.status != "choose") {
                var resB = this.inRectangle(mouseX, mouseY, this.endRect);
                this.endRect.status = resB ? "choose" : "";//选择状态
            }


            if (this.startRect.status == "choose") {
                this.offsetX = mouseX - this.startRect.x;
                this.offsetY = mouseY - this.startRect.y;

                this.draging = true; //
                canvas.style.cursor = "pointer"; // 更改鼠标样式为小手
            }

            if (this.endRect.status == "choose") {
                this.offsetX = mouseX - this.endRect.x;
                this.offsetY = mouseY - this.endRect.y;

                this.draging = true; //
                canvas.style.cursor = "pointer"; // 更改鼠标样式为小手
            }
        }

    }
    onMouseout() {
        this.mousein = false;
        this.render();
    }
    onMouseup() {
        this.draging = false; //恢复
        let canvas = this.canvas;
        canvas.style.cursor = "default"; // 恢复鼠标样式为默认样式
        this.startRect.status = "";//状态恢复
        this.endRect.status = "";//状态恢复
        this.offsetX = 0;
        this.offsetY = 0;

        this.objTimeSegments.forEach((item, index) => {
            item.status = ""//状态设置为空
        });
    }
    onResize() {
        this.width = window.innerWidth;
        this.render();
    }
    /**
     * 判断该点是否在矩形内
     * @param {*} x 
     * @param {*} y 
     * @param {*} rect 
     */
    inRectangle(x, y, rect) {

        let rectX = rect.x;

        if (x >= rectX && x <= rectX + rect.w && y >= rect.y && y <= rect.y + rect.h) {
            return true;
        }
        return false
    }
    unbindEvent() {
        let canvas = this.canvas;
        canvas.removeEventListener("mousemove", this.onMousemove);
        canvas.removeEventListener("mousedown", this.onMousedown);
        canvas.removeEventListener("mouseup", this.onMouseup);
        window.removeEventListener("resize", this.onResize);

    }
    onMousemove(event) {
        let canvas = this.canvas;
        var rect = canvas.getBoundingClientRect();
        var mouseX = event.clientX - rect.left;
        var mouseY = event.clientY - rect.top;

        if (mouseX < this.left) {
            return;
        }
        if (this.startRect.status == "choose") {
            // if (this.endRect.x - mouseX <= this.left) return;
            this.startRect.x = mouseX - this.offsetX;
        }

        if (this.endRect.status == "choose") {
            //if (mouseX - this.startRect.x <= this.left) return;
            this.endRect.x = mouseX - this.offsetX;
        }

        // 在这里可以使用鼠标的位置进行后续操作
        this.render();

        this.mousein = true;
        this.hoverLine.x = mouseX;
        this.hoverLine.y = mouseY;

        if (this.startRect.status == "choose") {
            this.hoverLine.x = this.startRect.x + this.left;
        }

        if (this.endRect.status == "choose") {
            this.hoverLine.x = this.endRect.x + this.left;
        }



        this.objTimeSegments.forEach((item, index) => {

            if (item.status == "choose") {
                item.x = mouseX - this.offsetX;
                item.x = item.x <= this.left ? this.left : item.x;
            }

            if (item.status == "left") {
                item.x = mouseX;
                item.x = item.x <= this.left ? this.left : item.x;
                item.w = item.x2 - item.x;
            }

            if (item.status == "right") {
                item.w = mouseX - item.x;
            }
        });


        this.hoverShow(this.hoverLine.x, this.hoverLine.y)
    }

    //显示当前鼠标位置
    hoverShow(x, y) {

        const MS_PER_PX = this.totalMS / this.width; // ms/px，每像素占的毫秒
        let text = this.convertTime(MS_PER_PX * (x - this.left), 1);
        this.drawText(text, x + 2, y, "rgba(0,255,255,1)", "12px Arial");
        this.drawLine(x, 0, x, this.height, 1, "rgba(151,158,167,1)");
    }

    render() {
        this.clearCanvas(this.width, this.height); //清除画布

        this.drawBack();
        this.drawTopLine();
        this.drawTimeSegments();
        this.addGraduations();
        this.drawStartLine();
        this.drawEndLine();
    }

    clearCanvas(w, h) {
        this.ctx.clearRect(0, 0, w, h);
    }
    drawBack() {
        this.drawRect(0, 0, this.width, this.height, "black");
    }
    //绘制时间段
    drawTimeSegments() {
        this.objTimeSegments.forEach((item, index) => {
            this.drawRect(item.x, item.y, item.w, item.h, item.color, item.status);
            this.drawText(item.name, item.x + item.w + 2, item.y + item.h, item.color, "12px Arial")
        });
    }
    //绘制时间刻度
    addGraduations() {

        this.ctx.beginPath();
        let gridNum = 30;
        // 一格多少毫秒
        let msPerGrid = this.totalMS / gridNum;
        // 每格间距，一格多少像素宽
        let pxPerGrid = this.width / gridNum;

        console.log("gridNum", gridNum);
        for (let i = 0; i < gridNum; i++) {
            let currentStartTimestamp = i * msPerGrid;
            let x = i * pxPerGrid + this.left;
            let h = 5 + this.top;
            let text = this.convertTime(currentStartTimestamp);
            var textWidth = this.ctx.measureText(text).width; // 获取文本的宽度
            this.drawText(text, x - textWidth / 2, h + 15, "rgba(0,255,255,1)", "12px Arial");
            this.drawLine(x, this.top, x, h, 1, "rgba(151,158,167,1)");
        }

    }

    drawTopLine() {
        this.drawLine(0, this.top, this.width, this.top, 1, "rgba(255,255,255,1)");
        this.drawLine(0, this.top + 25, this.width, this.top + 25, 1, "rgba(255,255,255,1)");
    }
    drawStartLine() {
        let x = this.startRect.x + this.left;
        let y = this.top;
        let text = "起点";
        var textWidth = this.ctx.measureText(text).width; // 获取文本的宽度
        this.drawText(text, x - textWidth / 2, 15, "green")
        let size = this.startRect.size;
        this.drawTriangle(x, y, size);
        this.drawDashLine(x, 26 + y, x, this.height);
    }
    drawEndLine() {
        let x = this.endRect.x + this.left;
        let y = this.top;
        let text = "终点";
        var textWidth = this.ctx.measureText(text).width; // 获取文本的宽度
        this.drawText(text, x - textWidth / 2, 15, "red")
        let size = this.endRect.size;
        this.drawTriangle(x, y, size);
        this.drawDashLine(x, 26 + y, x, this.height);
    }



    convertTime(milliseconds, precision = 0) {
        const totalSeconds = milliseconds / 1000;
        const months = Math.floor(totalSeconds / (60 * 60 * 24 * 30));
        const days = Math.floor(totalSeconds / (60 * 60 * 24)) % 30;
        const hours = Math.floor(totalSeconds / (60 * 60)) % 24;
        const minutes = Math.floor(totalSeconds / 60) % 60;
        //const seconds = totalSeconds % 60;

        let formattedTime = '';
        // if (months > 0) {
        //     formattedTime += months + ' 月';
        // }
        // if (days > 0) {
        //     formattedTime += days + ' 天';
        // }
        // if (hours > 0) {
        //     formattedTime += hours + ' 小时';
        // }
        // if (minutes > 0) {
        //     formattedTime += minutes + ' 分钟';
        // }
        // if (seconds > 0 || formattedTime === '') {
        //     formattedTime += seconds.toFixed(precision) + ' 秒';
        // }


        formattedTime += totalSeconds.toFixed(precision) + ' 秒';
        return formattedTime.trim();
    }


    drawPoint(x, y, color) {
        let context = this.ctx;
        context.beginPath();
        context.fillStyle = color;
        context.arc(x, y, 3, 0, Math.PI * 2);
        context.fill();
    }

    //绘制三角形
    drawTriangle(x, y, size, color = "#fff") {
        this.ctx.beginPath();
        this.ctx.moveTo(x, y); // 设置起始点坐标(10,30)
        this.ctx.lineTo(x - size, y - size); // 设置左上角的点坐标(0,20)
        this.ctx.lineTo(x + size, y - size); // 设置右上角的点坐标(20,20)
        this.ctx.closePath(); // 关闭路径
        this.ctx.fillStyle = color; // 设置填充颜色
        this.ctx.fill(); // 填充三角形
    }
    //绘制文本
    drawText(text, x, y, color = "#fff", font = "14px Arial") {
        this.ctx.font = font; // 设置文本的字体大小
        this.ctx.fillStyle = color; // 设置文本颜色为绿色
        this.ctx.fillText(text, x, y);
    }
    //绘制线
    drawLine(x1, y1, x2, y2, lineWidth = 1, color = "#fff") {
        this.ctx.beginPath();
        this.ctx.strokeStyle = color;
        this.ctx.lineWidth = lineWidth;
        this.ctx.moveTo(x1, y1);
        this.ctx.lineTo(x2, y2);
        this.ctx.closePath(); // 关闭路径
        this.ctx.stroke();
    }

    //绘制虚线
    drawDashLine(x1, y1, x2, y2, lineWidth = 1, color = "#fff") {

        this.ctx.beginPath();
        this.ctx.setLineDash([5, 3]); // 设置虚线样式，[虚线段长度, 间隔长度]
        this.ctx.strokeStyle = color; // 设置线条颜色
        this.ctx.lineWidth = lineWidth;
        this.ctx.moveTo(x1, y1);
        this.ctx.lineTo(x2, y2);
        //this.ctx.closePath(); // 关闭路径
        this.ctx.stroke(); // 绘制线条
        // 重置线条样式为实线
        this.ctx.setLineDash([]); // 重置虚线样式
    }

    //绘制矩形
    drawRect(x1, y1, w, h, fillStyle, selected) {
        this.ctx.fillStyle = fillStyle;
        this.ctx.fillRect(x1, y1, w, h);

        if (selected) {
            // 绘制矩形的四个点
            this.drawPoint(x1, y1, "red"); // 左上角点
            this.drawPoint(x1 + w, y1, "red"); // 右上角点
            this.drawPoint(x1, y1 + h, "red"); // 左下角点
            this.drawPoint(x1 + w, y1 + h, "red"); // 右下角点

            if (selected == "left") {
                this.hoverShow(x1, y1 + h);//左边
                return;
            }
            if (selected == "right") {
                this.hoverShow(x1 + w, y1 + h);//右边
            }
        }
    }
};


function generateRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";

    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
}


/**
 * 把时序数据转为表格数据
 * 0 就是s
 * 1 就是s1-s0
 * 2 就是s2-s1
 * @param {*} list 
 */
TimeLine.change2TableData = function (list) {

    // 使用 sort 方法按照 beginTime 进行排序
    list.sort((a, b) => {
        return a.beginTime - b.beginTime;
    });

    let res = [];
    let delay = 0;//延迟，秒数
    for (let i = 0; i < list.length; i++) {
        var item = list[i].item;
        delay = i == 0 ? list[i].beginTime / 1000 : (list[i].beginTime - list[i - 1].beginTime) / 1000;
        item.delay = delay.toFixed(1);
        res.push(item);
    }

    return res;
}

/**
 * 把表格转为时序数据
 * @param {*} tableData 
 * @returns 
 */
TimeLine.change2TimeSegments = function (tableData) {
    let startTime = 0;
    let endTime = 0;

    let timeSegments = tableData.map((item, index) => {
        var delay = item.delay * 1000; //与上个动作的延迟时间
        item.continue = 1; //本动作持续时间
        var continueTime = 0;//item.continue * 1000;

        startTime = index == 0 ? delay : endTime + delay;
        endTime = index == 0 ? startTime + continueTime : endTime + continueTime + delay;

        let s = {
            item: item,
            beginTime: startTime,
            endTime: endTime,
        };

        return s;
    });

    return timeSegments;
}
export default TimeLine;